
    import I18n from '@canvas/i18n/i18nObj';

    export default I18n.scoped('courses.syllabus');
  